var map = {
	"./Ahri_AcademySkin_HD.jpg": 67728,
	"./Ahri_AfterHoursSpiritBlossomSpringsSkin.jpg": 40356,
	"./Ahri_ArcadeSkin.jpg": 71515,
	"./Ahri_ArcanaSkin_HD.jpg": 50722,
	"./Ahri_ChallengerSkin_HD.jpg": 67593,
	"./Ahri_CovenSkin_HD.jpg": 96489,
	"./Ahri_DynastySkin_HD.jpg": 66998,
	"./Ahri_ElderwoodSkin_HD.jpg": 71271,
	"./Ahri_FoxfireSkin.jpg": 93270,
	"./Ahri_ImmortalizedLegendSkin_HD.jpg": 58246,
	"./Ahri_KDAALLOUTSkin.jpg": 13444,
	"./Ahri_KDASkin_HD.jpg": 23228,
	"./Ahri_MidnightSkin_HD.jpg": 96092,
	"./Ahri_OriginalSkin_HD.jpg": 33499,
	"./Ahri_PopstarSkin.jpg": 34472,
	"./Ahri_PrestigeKDASkin.jpg": 11126,
	"./Ahri_RisenLegendSkin_HD.jpg": 13890,
	"./Ahri_SnowMoonSkin.jpg": 89365,
	"./Ahri_SpiritBlossomSkin.jpg": 94943,
	"./Ahri_SpiritBlossomSpringsSkin.jpg": 9239,
	"./Ahri_StarGuardianSkin_HD.jpg": 12587,
	"./Akali_All-starSkin.jpg": 78689,
	"./Akali_BloodMoonSkin.jpg": 10542,
	"./Akali_CovenSkin.jpg": 55112,
	"./Akali_CrimeCityNightmareSkin.jpg": 69357,
	"./Akali_EmpyreanSkin_HD.jpg": 55235,
	"./Akali_HeadhunterSkin.jpg": 11055,
	"./Akali_InfernalSkin_HD.jpg": 46547,
	"./Akali_KDAALLOUTSkin.jpg": 30400,
	"./Akali_KDASkin_HD.jpg": 30552,
	"./Akali_NurseSkin_HD.jpg": 88463,
	"./Akali_OriginalSkin_HD.jpg": 73687,
	"./Akali_PROJECTSkin_HD.jpg": 71355,
	"./Akali_PrestigeCovenSkin.jpg": 87849,
	"./Akali_PrestigeKDASkin.jpg": 53018,
	"./Akali_SashimiSkin_HD.jpg": 55754,
	"./Akali_SilverfangSkin_HD.jpg": 64691,
	"./Akali_SpiritBlossomSkin.jpg": 13379,
	"./Akali_StarGuardianSkin.jpg": 59474,
	"./Akali_StingerSkin.jpg": 44015,
	"./Akali_TrueDamageSkin.jpg": 65572,
	"./Ambessa_ChosenoftheWolfSkin.jpg": 4591,
	"./Ambessa_OriginalSkin.jpg": 78634,
	"./Ashe_AmethystSkin_HD.jpg": 7518,
	"./Ashe_CosmicQueenSkin.jpg": 27440,
	"./Ashe_CovenSkin.jpg": 29461,
	"./Ashe_CrystalisMotusSkin_HD.jpg": 14355,
	"./Ashe_DRXSkin.jpg": 28650,
	"./Ashe_FaeDragonSkin_HD.jpg": 34182,
	"./Ashe_FreljordSkin_HD.jpg": 61217,
	"./Ashe_HeartseekerSkin.jpg": 25353,
	"./Ashe_HighNoonSkin.jpg": 97370,
	"./Ashe_InfernalSkin_HD.jpg": 60246,
	"./Ashe_LunarEmpressSkin.jpg": 41039,
	"./Ashe_MarauderSkin_HD.jpg": 61496,
	"./Ashe_OceanSongSkin_HD.jpg": 57958,
	"./Ashe_OriginalSkin.jpg": 12117,
	"./Ashe_PROJECTSkin_HD.jpg": 67320,
	"./Ashe_QueenSkin.jpg": 44366,
	"./Ashe_SherwoodForestSkin_HD.jpg": 52685,
	"./Ashe_SpiritBlossomSkin.jpg": 17822,
	"./Ashe_WoadSkin_HD.jpg": 22682,
	"./Ashe_Worlds2017Skin_HD.jpg": 31438,
	"./Aurora_BattleBunnySkin_HD.jpg": 75296,
	"./Aurora_OriginalSkin_HD.jpg": 14759,
	"./Bel27Veth_BattleBossSkin_HD.jpg": 16868,
	"./Bel27Veth_CosmicMatriarchSkin_HD.jpg": 43902,
	"./Bel27Veth_OriginalSkin_HD.jpg": 20452,
	"./Bel27Veth_PrimordianSkin_HD.jpg": 54234,
	"./Briar_OriginalSkin_HD.jpg": 15267,
	"./Briar_PrimordianSkin.jpg": 60752,
	"./Briar_StreetDemonsSkin_HD.jpg": 65003,
	"./Caitlyn_ArcadeSkin.jpg": 27331,
	"./Caitlyn_ArcaneCommanderSkin.jpg": 73225,
	"./Caitlyn_ArcaneEnforcerSkin.jpg": 70417,
	"./Caitlyn_ArcticWarfareSkin_HD.jpg": 79228,
	"./Caitlyn_BattleAcademiaSkin.jpg": 58918,
	"./Caitlyn_DRXSkin.jpg": 14035,
	"./Caitlyn_HeadhunterSkin_HD.jpg": 51588,
	"./Caitlyn_HeartthrobSkin_HD.jpg": 81743,
	"./Caitlyn_LunarWraithSkin_HD.jpg": 19861,
	"./Caitlyn_OfficerSkin.jpg": 95003,
	"./Caitlyn_OriginalSkin_HD.jpg": 9667,
	"./Caitlyn_PoolPartySkin_HD.jpg": 9984,
	"./Caitlyn_PrestigeArcadeSkin.jpg": 56920,
	"./Caitlyn_PrestigeArcaneCommanderSkin.jpg": 80500,
	"./Caitlyn_PulsefireSkin.jpg": 72078,
	"./Caitlyn_ResistanceSkin_HD.jpg": 69029,
	"./Caitlyn_SafariSkin_HD.jpg": 19988,
	"./Caitlyn_SheriffSkin.jpg": 91468,
	"./Caitlyn_SnowMoonSkin.jpg": 90109,
	"./Camille_ArcanaSkin.jpg": 68452,
	"./Camille_CovenSkin.jpg": 20763,
	"./Camille_OriginalSkin_HD.jpg": 60208,
	"./Camille_PrestigeWinterblessedSkin.jpg": 62788,
	"./Camille_ProgramSkin_HD.jpg": 49991,
	"./Camille_StrikeCommanderSkin.jpg": 53962,
	"./Camille_WinterblessedSkin.jpg": 88325,
	"./Camille_iGSkin.jpg": 90354,
	"./Cassiopeia_BewitchingSkin.jpg": 7836,
	"./Cassiopeia_CovenSkin.jpg": 44029,
	"./Cassiopeia_DesperadaSkin_HD.jpg": 532,
	"./Cassiopeia_EternumSkin_HD.jpg": 90851,
	"./Cassiopeia_JadeFangSkin_HD.jpg": 92521,
	"./Cassiopeia_MythicSkin_HD.jpg": 17467,
	"./Cassiopeia_OriginalSkin_HD.jpg": 45342,
	"./Cassiopeia_PrestigeMythmakerSkin.jpg": 44035,
	"./Cassiopeia_SirenSkin_HD.jpg": 78928,
	"./Cassiopeia_SpiritBlossomSkin.jpg": 75494,
	"./Diana_BattleQueenSkin_HD.jpg": 5105,
	"./Diana_BloodMoonSkin.jpg": 42571,
	"./Diana_DarkCosmicSkin_HD.jpg": 32899,
	"./Diana_DarkValkyrieSkin.jpg": 39051,
	"./Diana_DarkWatersSkin.jpg": 92320,
	"./Diana_FirecrackerSkin.jpg": 69775,
	"./Diana_HeavenscaleSkin_HD.jpg": 8486,
	"./Diana_InfernalSkin.jpg": 75557,
	"./Diana_LunarGoddessSkin.jpg": 34165,
	"./Diana_OriginalSkin.jpg": 68949,
	"./Diana_PrestigeBattleQueenSkin_HD.jpg": 64070,
	"./Diana_PrestigeDarkCosmicSkin_HD.jpg": 9634,
	"./Diana_SentinelSkin.jpg": 5784,
	"./Diana_WinterblessedSkin.jpg": 12463,
	"./Elise_BewitchingSkin_HD.jpg": 58508,
	"./Elise_BloodMoonSkin_HD.jpg": 35315,
	"./Elise_CovenSkin.jpg": 68616,
	"./Elise_DeathBlossomSkin_HD.jpg": 96931,
	"./Elise_OriginalSkin_HD.jpg": 42391,
	"./Elise_SKTT1Skin_HD.jpg": 47267,
	"./Elise_SuperGalaxySkin_HD.jpg": 67909,
	"./Elise_VictoriousSkin_HD.jpg": 99371,
	"./Elise_WitheredRoseSkin_HD.jpg": 49905,
	"./Evelynn_BloodMoonSkin_HD.jpg": 92854,
	"./Evelynn_CovenSkin.jpg": 3543,
	"./Evelynn_HighNoonSkin.jpg": 6404,
	"./Evelynn_KDAALLOUTSkin.jpg": 12035,
	"./Evelynn_KDASkin_HD.jpg": 88401,
	"./Evelynn_MasqueradeSkin_HD.jpg": 93149,
	"./Evelynn_OriginalSkin_HD.jpg": 10652,
	"./Evelynn_PrestigeHighNoonSkin_HD.jpg": 30660,
	"./Evelynn_PrestigeKDASkin_HD.jpg": 58450,
	"./Evelynn_SafecrackerSkin_HD.jpg": 7553,
	"./Evelynn_ShadowSkin_HD.jpg": 22363,
	"./Evelynn_SoulFighterSkin_HD.jpg": 15307,
	"./Evelynn_SpiritBlossomSkin.jpg": 17500,
	"./Evelynn_SugarRushSkin_HD.jpg": 41547,
	"./Evelynn_TangoSkin_HD.jpg": 69602,
	"./Fiora_BattleQueenSkin_HD.jpg": 60549,
	"./Fiora_BewitchingSkin_HD.jpg": 24101,
	"./Fiora_DragonmancerSkin_HD.jpg": 84124,
	"./Fiora_FaerieCourtSkin.jpg": 97841,
	"./Fiora_HeadmistressSkin_HD.jpg": 98409,
	"./Fiora_HeartpiercerSkin_HD.jpg": 19371,
	"./Fiora_LunarBeastSkin_HD.jpg": 48538,
	"./Fiora_NightravenSkin_HD.jpg": 61477,
	"./Fiora_OriginalSkin_HD.jpg": 23874,
	"./Fiora_PROJECTSkin_HD.jpg": 52996,
	"./Fiora_PoolPartySkin_HD.jpg": 8183,
	"./Fiora_PulsefireSkin.jpg": 35123,
	"./Fiora_RoyalGuardSkin_HD.jpg": 99561,
	"./Fiora_SoaringSwordSkin_HD.jpg": 51101,
	"./Fiora_iGSkin_HD.jpg": 7197,
	"./Gwen_BattleQueenSkin_HD.jpg": 94703,
	"./Gwen_CafeCutiesSkin_HD.jpg": 35905,
	"./Gwen_OriginalSkin_HD.jpg": 34432,
	"./Gwen_SoulFighterSkin_HD.jpg": 19199,
	"./Gwen_SpaceGrooveSkin.jpg": 25378,
	"./Illaoi_BattleBearSkin_HD.jpg": 1286,
	"./Illaoi_CosmicInvokerSkin_HD.jpg": 15640,
	"./Illaoi_OriginalSkin_HD.jpg": 76877,
	"./Illaoi_ResistanceSkin_HD.jpg": 93011,
	"./Irelia_AviatorSkin_HD.jpg": 1784,
	"./Irelia_DivineSwordSkin.jpg": 81689,
	"./Irelia_FrostbladeSkin_HD.jpg": 63972,
	"./Irelia_HighNoonSkin_HD.jpg": 69530,
	"./Irelia_MythmakerSkin.jpg": 79295,
	"./Irelia_NightbladeSkin_HD.jpg": 5344,
	"./Irelia_OrderoftheLotusSkin_HD.jpg": 65285,
	"./Irelia_OriginalSkin_HD.jpg": 60203,
	"./Irelia_PROJECTSkin_HD.jpg": 17023,
	"./Irelia_PorcelainSkin_HD.jpg": 85199,
	"./Irelia_PrestigePROJECTSkin_HD.jpg": 27184,
	"./Irelia_SentinelSkin_HD.jpg": 66544,
	"./Irelia_SpiritBlossomSkin.jpg": 20751,
	"./Irelia_iGSkin_HD.jpg": 66228,
	"./Janna_BewitchingSkin_HD.jpg": 45556,
	"./Janna_CrystalRoseSkin.jpg": 22018,
	"./Janna_CyberHaloSkin_HD.jpg": 85885,
	"./Janna_FnaticSkin_HD.jpg": 95817,
	"./Janna_ForecastSkin_HD.jpg": 30017,
	"./Janna_FrostQueenSkin_HD.jpg": 11400,
	"./Janna_GuardianoftheSandsSkin_HD.jpg": 14684,
	"./Janna_HeavenscaleSkin_HD.jpg": 76413,
	"./Janna_HextechSkin_HD.jpg": 38107,
	"./Janna_OriginalSkin_HD.jpg": 72495,
	"./Janna_PrestigeCyberHaloSkin_HD.jpg": 28630,
	"./Janna_SacredSwordSkin_HD.jpg": 32347,
	"./Janna_StarGuardianSkin_HD.jpg": 97463,
	"./Janna_TempestSkin_HD.jpg": 784,
	"./Janna_VictoriousSkin_HD.jpg": 87923,
	"./Jinx_AmbitiousElfSkin_HD.jpg": 2451,
	"./Jinx_ArcaneEnemySkin_HD.jpg": 73591,
	"./Jinx_ArcaneFracturedSkin.jpg": 57144,
	"./Jinx_BattleCatSkin_HD.jpg": 65147,
	"./Jinx_CafeCutiesSkin_HD.jpg": 80579,
	"./Jinx_CrimeCitySkin.jpg": 69943,
	"./Jinx_FirecrackerSkin_HD.jpg": 59140,
	"./Jinx_HeartseekerSkin_HD.jpg": 90622,
	"./Jinx_OdysseySkin_HD.jpg": 24379,
	"./Jinx_OriginalSkin_HD.jpg": 26386,
	"./Jinx_PROJECTSkin_HD.jpg": 84052,
	"./Jinx_PrestigeBattleCatSkin_HD.jpg": 51996,
	"./Jinx_StarGuardianSkin_HD.jpg": 26774,
	"./Jinx_T1Skin_HD.jpg": 18290,
	"./Jinx_ZombieSlayerSkin_HD.jpg": 75781,
	"./Kai27Sa_ArcadeSkin_HD.jpg": 48336,
	"./Kai27Sa_BulletAngelSkin_HD.jpg": 16283,
	"./Kai27Sa_DarkStarSkin.jpg": 64391,
	"./Kai27Sa_HeavenscaleSkin_HD.jpg": 65069,
	"./Kai27Sa_InkshadowSkin_HD.jpg": 33450,
	"./Kai27Sa_KDAALLOUTSkin.jpg": 38296,
	"./Kai27Sa_KDASkin_HD.jpg": 94864,
	"./Kai27Sa_LagoonDragonSkin_HD.jpg": 53867,
	"./Kai27Sa_OriginalSkin_HD.jpg": 1087,
	"./Kai27Sa_PrestigeKDAALLOUTSkin.jpg": 22845,
	"./Kai27Sa_PrestigeKDASkin_HD.jpg": 68751,
	"./Kai27Sa_StarGuardianSkin_HD.jpg": 26983,
	"./Kai27Sa_iGSkin_HD.jpg": 58096,
	"./Kalista_BloodMoonSkin_HD.jpg": 19344,
	"./Kalista_DawnbringerSkin.jpg": 74347,
	"./Kalista_FaerieCourtSkin_HD.jpg": 6714,
	"./Kalista_MarauderSkin_HD.jpg": 99812,
	"./Kalista_OriginalSkin_HD.jpg": 96658,
	"./Kalista_SKTT1Skin_HD.jpg": 91612,
	"./Karma_ConquerorSkin_HD.jpg": 74542,
	"./Karma_DarkStarSkin_HD.jpg": 72380,
	"./Karma_DawnbringerSkin.jpg": 91118,
	"./Karma_FaerieQueenSkin_HD.jpg": 80292,
	"./Karma_InfernalSkin_HD.jpg": 91887,
	"./Karma_OdysseySkin_HD.jpg": 9692,
	"./Karma_OrderoftheLotusSkin_HD.jpg": 52677,
	"./Karma_OriginalSkin_HD.jpg": 82475,
	"./Karma_RuinedSkin_HD.jpg": 16431,
	"./Karma_SakuraSkin_HD.jpg": 26429,
	"./Karma_SpiritBlossomSkin.jpg": 72751,
	"./Karma_SunGoddessSkin_HD.jpg": 52201,
	"./Karma_TranquilityDragonSkin.jpg": 37454,
	"./Karma_WardenSkin_HD.jpg": 69833,
	"./Karma_WinterWonderSkin_HD.jpg": 41254,
	"./Katarina_BattleAcademiaSkin_HD.jpg": 22822,
	"./Katarina_BattleQueenSkin_HD.jpg": 26953,
	"./Katarina_BilgewaterSkin_HD.jpg": 51019,
	"./Katarina_ChosenoftheWolfSkin.jpg": 55390,
	"./Katarina_DeathSwornSkin_HD.jpg": 57880,
	"./Katarina_FaerieCourtSkin_HD.jpg": 51102,
	"./Katarina_HighCommandSkin_HD.jpg": 14160,
	"./Katarina_HighNoonSkin_HD.jpg": 92063,
	"./Katarina_KittyCatSkin_HD.jpg": 5384,
	"./Katarina_MercenarySkin_HD.jpg": 24365,
	"./Katarina_OriginalSkin_HD.jpg": 71870,
	"./Katarina_PROJECTSkin_HD.jpg": 6064,
	"./Katarina_PrestigeFaerieCourtSkin_HD.jpg": 76849,
	"./Katarina_PrestigeMasqueoftheBlackRoseSkin.jpg": 54931,
	"./Katarina_RedCardSkin_HD.jpg": 31076,
	"./Katarina_SandstormSkin_HD.jpg": 66178,
	"./Katarina_SlayBelleSkin.jpg": 96385,
	"./Katarina_WarringKingdomsSkin_HD.jpg": 74483,
	"./Kayle_AetherWingSkin_HD.jpg": 89646,
	"./Kayle_BattlebornSkin.jpg": 70576,
	"./Kayle_DragonslayerSkin_HD.jpg": 99125,
	"./Kayle_EmpyreanSkin_HD.jpg": 12535,
	"./Kayle_ImmortalJourneySkin.jpg": 15008,
	"./Kayle_IronInquisitorSkin_HD.jpg": 55243,
	"./Kayle_JudgmentSkin_HD.jpg": 75532,
	"./Kayle_OriginalSkin.jpg": 66182,
	"./Kayle_PentakillIIILostChapterSkin_HD.jpg": 13182,
	"./Kayle_PentakillSkin_HD.jpg": 1694,
	"./Kayle_PrestigeEmpyreanSkin_HD.jpg": 10090,
	"./Kayle_PsyOpsSkin_HD.jpg": 64556,
	"./Kayle_RiotSkin_HD.jpg": 22486,
	"./Kayle_SilverSkin_HD.jpg": 89837,
	"./Kayle_SpiritBlossomSkin.jpg": 65311,
	"./Kayle_Sun-EaterSkin.jpg": 66235,
	"./Kayle_TranscendedSkin_HD.jpg": 51099,
	"./Kayle_ViridianSkin_HD.jpg": 66620,
	"./Kindred_PorcelainSkin_HD.jpg": 56262,
	"./Kindred_ShadowfireSkin_HD.jpg": 77135,
	"./Kindred_SpiritBlossomSkin.jpg": 75364,
	"./Kindred_SuperGalaxySkin_HD.jpg": 24288,
	"./LeBlanc_BewitchingSkin_HD.jpg": 46305,
	"./LeBlanc_CovenSkin_HD.jpg": 18966,
	"./LeBlanc_DebonairSkin_HD.jpg": 83291,
	"./LeBlanc_ElderwoodSkin_HD.jpg": 97564,
	"./LeBlanc_MistletoeSkin.jpg": 96282,
	"./LeBlanc_OriginalSkin.jpg": 67941,
	"./LeBlanc_PrestigeCovenSkin_HD.jpg": 79085,
	"./LeBlanc_PrestigiousSkin_HD.jpg": 9535,
	"./LeBlanc_ProgramSkin_HD.jpg": 59697,
	"./LeBlanc_RavenbornSkin_HD.jpg": 18152,
	"./LeBlanc_RisenLegendSkin_HD.jpg": 15813,
	"./LeBlanc_WickedSkin.jpg": 68273,
	"./LeBlanc_Worlds2020Skin_HD.jpg": 20616,
	"./LeBlanc_iGSkin_HD.jpg": 66153,
	"./Leona_BarbecueSkin_HD.jpg": 92884,
	"./Leona_BattleAcademiaSkin_HD.jpg": 59968,
	"./Leona_BattleLionSkin_HD.jpg": 63967,
	"./Leona_CrystalisMotusSkin_HD.jpg": 6197,
	"./Leona_DWGSkin_HD.jpg": 22601,
	"./Leona_DebonairSkin_HD.jpg": 10141,
	"./Leona_DefenderSkin_HD.jpg": 57360,
	"./Leona_HighNoonSkin_HD.jpg": 17285,
	"./Leona_IronSolariSkin_HD.jpg": 39805,
	"./Leona_LunarEclipseSkin_HD.jpg": 61446,
	"./Leona_MechaKingdomsSkin_HD.jpg": 20941,
	"./Leona_OriginalSkin_HD.jpg": 51032,
	"./Leona_PROJECTSkin_HD.jpg": 56822,
	"./Leona_PoolPartySkin.jpg": 91008,
	"./Leona_PrestigeBattleAcademiaSkin_HD.jpg": 75037,
	"./Leona_PrestigeBattleLionSkin_HD.jpg": 46042,
	"./Leona_SolarEclipseSkin_HD.jpg": 98161,
	"./Leona_ValkyrieSkin_HD.jpg": 88558,
	"./Lillia_FaerieCourtSkin_HD.jpg": 72364,
	"./Lillia_NightbringerSkin.jpg": 69253,
	"./Lillia_OriginalSkin_HD.jpg": 82852,
	"./Lillia_ShanHaiScrollsSkin.jpg": 24078,
	"./Lillia_SpiritBlossomSkin.jpg": 92564,
	"./Lissandra_BladeQueenSkin_HD.jpg": 70729,
	"./Lissandra_BloodstoneSkin_HD.jpg": 49056,
	"./Lissandra_CovenSkin_HD.jpg": 93806,
	"./Lissandra_DarkCosmicSkin_HD.jpg": 42555,
	"./Lissandra_OriginalSkin_HD.jpg": 17294,
	"./Lissandra_PorcelainSkin_HD.jpg": 35612,
	"./Lissandra_PrestigePorcelainSkin_HD.jpg": 56811,
	"./Lissandra_ProgramSkin_HD.jpg": 94857,
	"./Lissandra_SpaceGrooveSkin_HD.jpg": 34629,
	"./Lux_BattleAcademiaSkin_HD.jpg": 20196,
	"./Lux_CommandoSkin_HD.jpg": 64777,
	"./Lux_CosmicSkin_HD.jpg": 76461,
	"./Lux_DarkCosmicSkin_HD.jpg": 57969,
	"./Lux_ElementalistSkin_HD.jpg": 46208,
	"./Lux_EmpyreanSkin_HD.jpg": 65304,
	"./Lux_FaerieCourtSkin_HD.jpg": 93452,
	"./Lux_ImperialSkin_HD.jpg": 54490,
	"./Lux_LunarEmpressSkin_HD.jpg": 51098,
	"./Lux_OriginalSkin_HD.jpg": 76388,
	"./Lux_PajamaGuardianSkin_HD.jpg": 16944,
	"./Lux_PorcelainSkin_HD.jpg": 84246,
	"./Lux_PrestigeBattleAcademiaSkin_HD.jpg": 72769,
	"./Lux_PrestigePorcelainSkin_HD.jpg": 26177,
	"./Lux_SorceressSkin_HD.jpg": 52248,
	"./Lux_SoulFighterSkin_HD.jpg": 31955,
	"./Lux_SpaceGrooveSkin_HD.jpg": 67515,
	"./Lux_SpellthiefSkin_HD.jpg": 97033,
	"./Lux_StarGuardianSkin_HD.jpg": 24164,
	"./Lux_SteelLegionSkin_HD.jpg": 30790,
	"./Mel_ArcaneCouncilorSkin.jpg": 66511,
	"./Mel_OriginalSkin.jpg": 51016,
	"./MissFortune_PajamaGuardianSkin_HD.jpg": 10320,
	"./Miss_Fortune_AdmiralBattleBunnySkin_HD.jpg": 92434,
	"./Miss_Fortune_ArcadeSkin_HD.jpg": 11790,
	"./Miss_Fortune_BattleBunnySkin_HD.jpg": 40466,
	"./Miss_Fortune_BattleQueenSkin_HD.jpg": 89688,
	"./Miss_Fortune_BewitchingSkin_HD.jpg": 97662,
	"./Miss_Fortune_BrokenCovenantSkin_HD.jpg": 10175,
	"./Miss_Fortune_CandyCaneSkin_HD.jpg": 192,
	"./Miss_Fortune_CaptainFortuneSkin_HD.jpg": 8207,
	"./Miss_Fortune_CowgirlSkin_HD.jpg": 37237,
	"./Miss_Fortune_CrimeCitySkin_HD.jpg": 32997,
	"./Miss_Fortune_GunGoddessSkin_HD.jpg": 33815,
	"./Miss_Fortune_OriginalSkin_HD.jpg": 41629,
	"./Miss_Fortune_PoolPartySkin_HD.jpg": 41930,
	"./Miss_Fortune_PorcelainSkin.jpg": 96264,
	"./Miss_Fortune_PrestigeBewitchingSkin_HD.jpg": 11683,
	"./Miss_Fortune_PrestigeBrokenCovenantSkin_HD.jpg": 54398,
	"./Miss_Fortune_RoadWarriorSkin_HD.jpg": 52744,
	"./Miss_Fortune_RuinedSkin_HD.jpg": 47905,
	"./Miss_Fortune_SecretAgentSkin_HD.jpg": 80645,
	"./Miss_Fortune_StarGuardianSkin_HD.jpg": 94649,
	"./Miss_Fortune_WaterlooSkin_HD.jpg": 51429,
	"./Morgana_BewitchingSkin_HD.jpg": 62253,
	"./Morgana_BlackthornSkin_HD.jpg": 96897,
	"./Morgana_BladeMistressSkin_HD.jpg": 77609,
	"./Morgana_CovenSkin.jpg": 6473,
	"./Morgana_DawnbringerSkin_HD.jpg": 66900,
	"./Morgana_ExiledSkin.jpg": 20031,
	"./Morgana_GhostBrideSkin_HD.jpg": 4980,
	"./Morgana_MajesticEmpressSkin_HD.jpg": 19172,
	"./Morgana_OriginalSkin.jpg": 9121,
	"./Morgana_PorcelainSkin.jpg": 27287,
	"./Morgana_PrestigeBewitchingSkin_HD.jpg": 51800,
	"./Morgana_SinfulSucculenceSkin_HD.jpg": 11320,
	"./Morgana_SnowMoonSkin_HD.jpg": 39607,
	"./Morgana_SpiritBlossomSkin.jpg": 62170,
	"./Morgana_StarNemesisSkin.jpg": 72464,
	"./Morgana_VictoriousSkin_HD.jpg": 77702,
	"./Nami_BewitchingSkin_HD.jpg": 63601,
	"./Nami_CosmicDestinySkin_HD.jpg": 64077,
	"./Nami_CovenSkin.jpg": 32341,
	"./Nami_DeepSeaSkin_HD.jpg": 81368,
	"./Nami_KoiSkin_HD.jpg": 96612,
	"./Nami_MythmakerSkin.jpg": 72270,
	"./Nami_OriginalSkin_HD.jpg": 23206,
	"./Nami_PrestigeSpaceGrooveSkin_HD.jpg": 32046,
	"./Nami_ProgramSkin_HD.jpg": 85569,
	"./Nami_RiverSpiritSkin_HD.jpg": 51602,
	"./Nami_SKTT1Skin_HD.jpg": 75192,
	"./Nami_SpaceGrooveSkin_HD.jpg": 78813,
	"./Nami_SplendidStaffSkin_HD.jpg": 95554,
	"./Nami_UrftheNamiteeSkin_HD.jpg": 68284,
	"./Neeko_BewitchingSkin_HD.jpg": 16354,
	"./Neeko_OriginalSkin_HD.jpg": 7945,
	"./Neeko_PrestigeStarGuardianSkin_HD.jpg": 69632,
	"./Neeko_ShanHaiScrollsSkin_HD.jpg": 79506,
	"./Neeko_StarGuardianSkin_HD.jpg": 74829,
	"./Neeko_StreetDemonsSkin_HD.jpg": 77973,
	"./Neeko_WinterWonderSkin_HD.jpg": 6432,
	"./Nidalee_BewitchingSkin_HD.jpg": 24864,
	"./Nidalee_ChallengerSkin_HD.jpg": 85713,
	"./Nidalee_CosmicHuntressSkin_HD.jpg": 75472,
	"./Nidalee_DWGSkin_HD.jpg": 59940,
	"./Nidalee_DawnbringerSkin_HD.jpg": 95211,
	"./Nidalee_FrenchMaidSkin_HD.jpg": 82511,
	"./Nidalee_HeadhunterSkin_HD.jpg": 98228,
	"./Nidalee_KittaleeSkin_HD.jpg": 68379,
	"./Nidalee_LaIlusiC3B3nSkin_HD.jpg": 68150,
	"./Nidalee_LeopardSkin_HD.jpg": 89539,
	"./Nidalee_OceanSongSkin_HD.jpg": 40013,
	"./Nidalee_OriginalSkin_HD.jpg": 38867,
	"./Nidalee_PharaohSkin_HD.jpg": 93535,
	"./Nidalee_SnowBunnySkin_HD.jpg": 35067,
	"./Nidalee_SpiritBlossomSkin.jpg": 3431,
	"./Nidalee_SuperGalaxySkin_HD.jpg": 28089,
	"./Nidalee_WarringKingdomsSkin_HD.jpg": 25264,
	"./Nilah_CovenSkin_HD.jpg": 49671,
	"./Nilah_InkshadowSkin.jpg": 86959,
	"./Nilah_OriginalSkin_HD.jpg": 47157,
	"./Nilah_StarGuardianSkin_HD.jpg": 4641,
	"./Orianna_BladecraftSkin_HD.jpg": 47902,
	"./Orianna_DarkStarSkin_HD.jpg": 82626,
	"./Orianna_GothicSkin_HD.jpg": 54052,
	"./Orianna_HeartseekerSkin_HD.jpg": 23819,
	"./Orianna_OrbeeannaSkin_HD.jpg": 80141,
	"./Orianna_OriginalSkin_HD.jpg": 22529,
	"./Orianna_PoolPartySkin.jpg": 24149,
	"./Orianna_SewnChaosSkin_HD.jpg": 62263,
	"./Orianna_StarGuardianSkin.jpg": 90064,
	"./Orianna_T1Skin_HD.jpg": 43797,
	"./Orianna_TPASkin_HD.jpg": 93967,
	"./Orianna_VictoriousSkin_HD.jpg": 8901,
	"./Orianna_WinterWonderSkin_HD.jpg": 22120,
	"./Qiyana_BattleBossSkin_HD.jpg": 55384,
	"./Qiyana_BattleQueenSkin_HD.jpg": 72847,
	"./Qiyana_LaIlusiC3B3nSkin_HD.jpg": 80881,
	"./Qiyana_LunarEmpressSkin.jpg": 10501,
	"./Qiyana_OriginalSkin_HD.jpg": 28192,
	"./Qiyana_PrestigeBattleAcademiaSkin.jpg": 42224,
	"./Qiyana_PrestigeTrueDamageSkin_HD.jpg": 61295,
	"./Qiyana_ShockbladeSkin_HD.jpg": 26972,
	"./Qiyana_TrueDamageSkin_HD.jpg": 22302,
	"./Quinn_CorsairSkin_HD.jpg": 17080,
	"./Quinn_HeartseekerSkin_HD.jpg": 69148,
	"./Quinn_OriginalSkin_HD.jpg": 55228,
	"./Quinn_PhoenixSkin_HD.jpg": 89612,
	"./Quinn_StarGuardianSkin.jpg": 77275,
	"./Quinn_WardenSkin_HD.jpg": 92918,
	"./Quinn_WoadScoutSkin_HD.jpg": 50384,
	"./Rell_BattleQueenSkin.jpg": 92526,
	"./Rell_GrandReckoningSkin.jpg": 93746,
	"./Rell_HighNoonSkin_HD.jpg": 57345,
	"./Rell_OriginalSkin_HD.jpg": 23180,
	"./Rell_StarGuardianSkin_HD.jpg": 49244,
	"./Renata_Glasc_AdmiralGlascSkin_HD.jpg": 74914,
	"./Renata_Glasc_LaIlusiC3B3nSkin_HD.jpg": 41534,
	"./Renata_Glasc_MasqueoftheBlackRoseSkin.jpg": 54071,
	"./Renata_Glasc_OriginalSkin_HD.jpg": 86875,
	"./Renata_Glasc_PrestigeLaIlusiónSkin.jpg": 97792,
	"./Riven_ArcadeSkin_HD.jpg": 89878,
	"./Riven_BattleBunnyPrimeSkin_HD.jpg": 5895,
	"./Riven_BattleBunnySkin_HD.jpg": 20426,
	"./Riven_BrokenCovenantSkin_HD.jpg": 21415,
	"./Riven_CrimsonEliteSkin_HD.jpg": 19118,
	"./Riven_DawnbringerSkin_HD.jpg": 47501,
	"./Riven_DragonbladeSkin_HD.jpg": 73815,
	"./Riven_PrestigeValiantSwordSkin_HD.jpg": 92507,
	"./Riven_PrimalAmbushSkin_HD.jpg": 80743,
	"./Riven_PulsefireSkin_HD.jpg": 91053,
	"./Riven_RedeemedSkin_HD.jpg": 57095,
	"./Riven_SentinelSkin_HD.jpg": 47102,
	"./Riven_SpiritBlossomSkin.jpg": 71577,
	"./Riven_ValiantSwordSkin_HD.jpg": 21054,
	"./Riven_Worlds2012Skin_HD.jpg": 9478,
	"./Samira_HighNoonSkin_HD.jpg": 7747,
	"./Samira_MasqueoftheBlackRoseSkin.jpg": 92688,
	"./Samira_OriginalSkin.jpg": 45361,
	"./Samira_PsyOpsSkin_HD.jpg": 29325,
	"./Samira_SoulFighterSkin_HD.jpg": 86969,
	"./Samira_SpaceGrooveSkin_HD.jpg": 39545,
	"./Sejuani_DarkriderSkin_HD.jpg": 97383,
	"./Sejuani_DawnchaserSkin.jpg": 48340,
	"./Sejuani_FirecrackerSkin_HD.jpg": 45778,
	"./Sejuani_HextechSkin_HD.jpg": 91286,
	"./Sejuani_OriginalSkin_HD.jpg": 98864,
	"./Sejuani_PROJECTSkin_HD.jpg": 30414,
	"./Sejuani_PoroRiderSkin_HD.jpg": 88357,
	"./Sejuani_SabretuskSkin_HD.jpg": 27129,
	"./Sejuani_SolarEclipseSkin_HD.jpg": 56121,
	"./Sejuani_TraditionalSkin_HD.jpg": 30094,
	"./Sejuani_VictoriousSkin.jpg": 31515,
	"./Senna_BewitchingSkin.jpg": 91128,
	"./Senna_HighNoonSkin_HD.jpg": 81811,
	"./Senna_LunarEclipseSkin.jpg": 40263,
	"./Senna_MaskedJusticeSkin.jpg": 19054,
	"./Senna_OriginalSkin_HD.jpg": 40826,
	"./Senna_PROJECTSkin.jpg": 19275,
	"./Senna_PrestigeLunarEclipseSkin.jpg": 25332,
	"./Senna_PrestigeTrueDamageSkin_HD.jpg": 73533,
	"./Senna_StarGuardianSkin.jpg": 61069,
	"./Senna_TrueDamageSkin_HD.jpg": 14096,
	"./Senna_WinterblessedSkin_HD.jpg": 20804,
	"./Seraphine_BattleDoveSkin_HD.jpg": 94321,
	"./Seraphine_DumplingDarlingsSkin.jpg": 18012,
	"./Seraphine_FaerieCourtSkin.jpg": 7775,
	"./Seraphine_GracefulPhoenixSkin.jpg": 29768,
	"./Seraphine_KDAALLOUTIndieSkin.jpg": 28360,
	"./Seraphine_KDAALLOUTRisingStarSkin.jpg": 78605,
	"./Seraphine_KDAALLOUTSuperstarSkin_HD.jpg": 30769,
	"./Seraphine_OceanSongSkin_HD.jpg": 35248,
	"./Seraphine_OriginalSkin_HD.jpg": 40040,
	"./Seraphine_PrestigeOceanSongSkin.jpg": 31138,
	"./Seraphine_StarGuardianSkin.jpg": 99719,
	"./Shyvana_BoneclawSkin_HD.jpg": 69619,
	"./Shyvana_DarkflameSkin_HD.jpg": 64139,
	"./Shyvana_IceDrakeSkin_HD.jpg": 8646,
	"./Shyvana_ImmortalJourneySkin.jpg": 61682,
	"./Shyvana_IronscaleSkin_HD.jpg": 25240,
	"./Shyvana_OriginalSkin_HD.jpg": 39665,
	"./Shyvana_RuinedSkin_HD.jpg": 52997,
	"./Shyvana_SuperGalaxySkin_HD.jpg": 48407,
	"./Shyvana_Worlds2014Skin_HD.jpg": 18568,
	"./Sivir_Ann-Sivir-sarySkin_HD.jpg": 28976,
	"./Sivir_BanditSkin_HD.jpg": 59417,
	"./Sivir_BloodMoonSkin_HD.jpg": 63734,
	"./Sivir_CafeCutiesSkin_HD.jpg": 31445,
	"./Sivir_HuntressSkin_HD.jpg": 81197,
	"./Sivir_MythmakerSkin.jpg": 83400,
	"./Sivir_NeoPAXSkin_HD.jpg": 27016,
	"./Sivir_OdysseySkin_HD.jpg": 96989,
	"./Sivir_OriginalSkin.jpg": 14763,
	"./Sivir_PAXSkin_HD.jpg": 32422,
	"./Sivir_PizzaDeliverySkin_HD.jpg": 25425,
	"./Sivir_PrestigeMythmakerSkin.jpg": 28849,
	"./Sivir_PrimalAmbushSkin_HD.jpg": 65230,
	"./Sivir_SnowstormSkin_HD.jpg": 81767,
	"./Sivir_SolarEclipseSkin_HD.jpg": 37373,
	"./Sivir_SpectacularSkin_HD.jpg": 43136,
	"./Sivir_VictoriousSkin_HD.jpg": 81296,
	"./Sivir_WardenSkin_HD.jpg": 67830,
	"./Sivir_WarriorPrincessSkin_HD.jpg": 72186,
	"./Sona_ArcadeSkin.jpg": 53056,
	"./Sona_DJSkin_HD.jpg": 47843,
	"./Sona_GuqinSkin_HD.jpg": 10738,
	"./Sona_ImmortalJourneySkin_HD.jpg": 96122,
	"./Sona_MuseSkin_HD.jpg": 76023,
	"./Sona_OdysseySkin_HD.jpg": 46791,
	"./Sona_OriginalSkin_HD.jpg": 18222,
	"./Sona_PentakillIIILostChapterSkin_HD.jpg": 35805,
	"./Sona_PentakillSkin_HD.jpg": 49225,
	"./Sona_PrestigeImmortalJourneySkin_HD.jpg": 63561,
	"./Sona_PsyOpsSkin_HD.jpg": 49593,
	"./Sona_SilentNightSkin_HD.jpg": 8976,
	"./Sona_SpiritBlossomSpringsSkin.jpg": 70444,
	"./Sona_StarGuardianSkin.jpg": 9505,
	"./Sona_SweetheartSkin_HD.jpg": 10461,
	"./Sona_VictoriousSkin_HD.jpg": 78882,
	"./Soraka_CafeCutiesSkin_HD.jpg": 89779,
	"./Soraka_CelestineSkin_HD.jpg": 10987,
	"./Soraka_DawnbringerSkin_HD.jpg": 64012,
	"./Soraka_DivineSkin_HD.jpg": 28314,
	"./Soraka_DryadSkin_HD.jpg": 83949,
	"./Soraka_FaerieCourtSkin_HD.jpg": 7530,
	"./Soraka_NightbringerSkin_HD.jpg": 77096,
	"./Soraka_OrderoftheBananaSkin_HD.jpg": 71800,
	"./Soraka_OriginalSkin_HD.jpg": 28226,
	"./Soraka_PrestigeStarGuardianSkin_HD.jpg": 59091,
	"./Soraka_ProgramSkin_HD.jpg": 16221,
	"./Soraka_ReaperSkin_HD.jpg": 73138,
	"./Soraka_SpiritBlossomSkin_HD.jpg": 23151,
	"./Soraka_StarGuardianSkin_HD.jpg": 31846,
	"./Soraka_WinterWonderSkin_HD.jpg": 26235,
	"./Syndra_AtlanteanSkin_HD.jpg": 34161,
	"./Syndra_BewitchingSkin_HD.jpg": 78709,
	"./Syndra_CovenSkin_HD.jpg": 20074,
	"./Syndra_DumplingDarlingsSkin.jpg": 61806,
	"./Syndra_JusticarSkin_HD.jpg": 30608,
	"./Syndra_OriginalSkin_HD.jpg": 20338,
	"./Syndra_PoolPartySkin_HD.jpg": 92327,
	"./Syndra_PrestigeStarGuardianSkin.jpg": 82750,
	"./Syndra_QueenofDiamondsSkin_HD.jpg": 43915,
	"./Syndra_SKTT1Skin_HD.jpg": 81564,
	"./Syndra_SnowDaySkin_HD.jpg": 85186,
	"./Syndra_SpiritBlossomSkin_HD.jpg": 66143,
	"./Syndra_StarGuardianSkin_HD.jpg": 56886,
	"./Syndra_WitheredRoseSkin.jpg": 35951,
	"./Taliyah_CrystalisMotusSkin.jpg": 95411,
	"./Taliyah_OriginalSkin_HD.jpg": 49009,
	"./Taliyah_SSGSkin_HD.jpg": 671,
	"./Taliyah_StarGuardianSkin.jpg": 95360,
	"./Vayne_ArclightSkin_HD.jpg": 11743,
	"./Vayne_AristocratSkin_HD.jpg": 22749,
	"./Vayne_BattleBatSkin_HD.jpg": 77710,
	"./Vayne_DawnbringerSkin_HD.jpg": 71402,
	"./Vayne_DragonmancerSkin_HD.jpg": 70958,
	"./Vayne_DragonslayerSkin_HD.jpg": 57034,
	"./Vayne_FPXSkin_HD.jpg": 48829,
	"./Vayne_FirecrackerSkin_HD.jpg": 6746,
	"./Vayne_HeartseekerSkin_HD.jpg": 68728,
	"./Vayne_OriginalSkin_HD.jpg": 29816,
	"./Vayne_PROJECTSkin_HD.jpg": 15414,
	"./Vayne_PrestigeFirecrackerSkin.jpg": 23300,
	"./Vayne_SKTT1Skin_HD.jpg": 9326,
	"./Vayne_SentinelSkin.jpg": 90518,
	"./Vayne_SoulstealerSkin_HD.jpg": 26170,
	"./Vayne_SpiritBlossomSkin_HD.jpg": 59429,
	"./Vayne_VindicatorSkin_HD.jpg": 19108,
	"./Vi_ArcaneBrawlerSkin.jpg": 71205,
	"./Vi_ArcaneUndercitySkin.jpg": 33351,
	"./Vi_DebonairSkin_HD.jpg": 98729,
	"./Vi_DemonSkin_HD.jpg": 20508,
	"./Vi_HeartacheSkin_HD.jpg": 46956,
	"./Vi_HeartbreakerSkin_HD.jpg": 36463,
	"./Vi_NeonStrikeSkin_HD.jpg": 4185,
	"./Vi_OfficerSkin.jpg": 14584,
	"./Vi_OriginalSkin.jpg": 66419,
	"./Vi_PROJECTSkin_HD.jpg": 74130,
	"./Vi_PrimalAmbushSkin_HD.jpg": 79750,
	"./Vi_PsyOpsSkin_HD.jpg": 23691,
	"./Vi_WarringKingdomsSkin_HD.jpg": 25485,
	"./Xayah_ArcanaSkin_HD.jpg": 47339,
	"./Xayah_BattleAcademiaSkin.jpg": 46925,
	"./Xayah_BattleBatSkin_HD.jpg": 85440,
	"./Xayah_BravePhoenixSkin_HD.jpg": 44724,
	"./Xayah_BrokenCovenantSkin_HD.jpg": 11192,
	"./Xayah_CosmicDuskSkin_HD.jpg": 21614,
	"./Xayah_ElderwoodSkin_HD.jpg": 66444,
	"./Xayah_OriginalSkin.jpg": 7061,
	"./Xayah_PrestigeBravePhoenixSkin_HD.jpg": 28153,
	"./Xayah_SSGSkin_HD.jpg": 7690,
	"./Xayah_StarGuardianSkin_HD.jpg": 85442,
	"./Xayah_SweetheartSkin_HD.jpg": 78837,
	"./Yunara_OriginalSkin.jpg": 70740,
	"./Yunara_SpiritBlossomSpringsSkin.jpg": 32781,
	"./Zeri_FrightNightSkin.jpg": 46775,
	"./Zeri_ImmortalJourneySkin.jpg": 88400,
	"./Zeri_OceanSongSkin.jpg": 97120,
	"./Zeri_OriginalSkin.jpg": 54518,
	"./Zeri_PrestigeFrightNightSkin.jpg": 96370,
	"./Zeri_WitheredRoseSkin.jpg": 17464,
	"./Zyra_BloodMoonSkin_HD.jpg": 88747,
	"./Zyra_CrimeCityNightmareSkin_HD.jpg": 10246,
	"./Zyra_CrystalRoseSkin_HD.jpg": 61103,
	"./Zyra_DragonSorceressSkin_HD.jpg": 40752,
	"./Zyra_HauntedSkin_HD.jpg": 53747,
	"./Zyra_MythmakerSkin.jpg": 14083,
	"./Zyra_OriginalSkin_HD.jpg": 42623,
	"./Zyra_SKTT1Skin_HD.jpg": 55880,
	"./Zyra_SpiritBlossomSkin.jpg": 20123,
	"./Zyra_StreetDemonsSkin_HD.jpg": 73519,
	"./Zyra_WildfireSkin_HD.jpg": 37072
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 56512;